
const BusPlugin = {
	install(Vue) {
		const BUS = new Vue()

		Vue.bus = BUS
		Vue.prototype.$bus = BUS
	},
}

if (typeof window !== 'undefined' && window.Vue) {
	window.Vue.use(BusPlugin)
}

export default BusPlugin



// WEBPACK FOOTER //
// ./src/lib/bus/index.js